export default "__VITE_ASSET__DXhW2u8R__"